import { render, staticRenderFns } from "./BeneficiarioImportacaoFiltro.vue?vue&type=template&id=398d70e8&scoped=true"
import script from "./BeneficiarioImportacaoFiltro.vue?vue&type=script&lang=js"
export * from "./BeneficiarioImportacaoFiltro.vue?vue&type=script&lang=js"
import style0 from "./BeneficiarioImportacaoFiltro.vue?vue&type=style&index=0&id=398d70e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d70e8",
  null
  
)

export default component.exports